// 配置编译环境和线上环境之间的切换
const CONFIG = {
  // 开发环境
  development: {
    iconfontVersion: ['567566_82imxaft0by'],
    iconfontUrl: '//at.alicdn.com/t/font_$key.css',
    baseURL: '/dev-api',
    // baseURL: '/',
    loginUrl: process.env.VUE_APP_LOGINURL,
    ferryUrl: process.env.VUE_APP_FERRYURL,
    // ferryUrl: '/gateway/api-boss',
    officeUrl: process.env.VUE_APP_OFFICEURL,
    agentUrl: process.env.VUE_APP_AGENTURL,
    uploadUrl: process.env.VUE_APP_UPLOADURL,
    // uploadUrl: '/dev-api',
    importExcelUrl: process.env.VUE_APP_IMPORTEXCELURL
    /* iconfontVersion: ['567566_82imxaft0by'],
        iconfontUrl: `//at.alicdn.com/t/font_$key.css`,
        baseURL: '/dev-api',
        loginUrl: '/custom-auth',
        ferryUrl: '/gateway/api-boss',
        officeUrl: '/gateway/api-office',
        agentUrl:'/gateway/api-agent',
        uploadUrl: 'https://custom.ayundi.cn',
        importExcelUrl: 'https://custom.ayundi.cn' */
  },
  // 测试环境环境
  test: {
    iconfontVersion: ['567566_82imxaft0by'],
    iconfontUrl: '//at.alicdn.com/t/font_$key.css',
    baseURL: '/',
    loginUrl: '/custom-auth',
    ferryUrl: '/gateway-test/api-boss',
    officeUrl: '/gateway-test/api-office',
    // ferryUrl: '/gateway/api-boss',
    agentUrl: '/gateway-test/api-agent',
    uploadUrl: 'https://custom-dev.ayundi.cn',
    importExcelUrl: 'https://custom-dev.ayundi.cn'
  },
  // 预发布环境
  preview: {
    iconfontVersion: ['567566_82imxaft0by'],
    iconfontUrl: '//at.alicdn.com/t/font_$key.css',
    baseURL: '/',
    loginUrl: '/custom-auth',
    ferryUrl: '/gateway/api-boss',
    officeUrl: '/gateway/api-office',
    agentUrl: '/gateway/api-agent',
    uploadUrl: 'https://custom-pre.ayundi.cn',
    importExcelUrl: 'https://custom-pre.ayundi.cn'
  },
  // 生产环境
  production: {
    iconfontVersion: ['567566_82imxaft0by'],
    iconfontUrl: '//at.alicdn.com/t/font_$key.css',
    baseURL: '/',
    loginUrl: '/custom-auth',
    ferryUrl: '/gateway/api-boss',
    officeUrl: '/gateway/api-office',
    agentUrl: '/gateway/api-agent',
    uploadUrl: 'https://custom.ayundi.cn',
    importExcelUrl: 'https://custom.ayundi.cn'
  }
}
export default CONFIG[process.env.VUE_APP_FERRY_SERVICE_ENV]
